import { type ThemeConfig } from 'antd';

export const antdTheme = {
  token: {
    colorPrimary: '#FFBC00',
    colorSecondary: '#0D2772',
    colorTextLightSolid: '#000000',
    colorBgLayout: '#fcfcfc',
    colorBgTextHover: 'rgba(0, 0, 0, 0.03)',
    fontFamily: "'Roboto', sans-serif",
    fontSize: 16,
    borderRadius: 4
  },
  components: {
    Tooltip: {
      colorBgSpotlight: '#FFBC00'
    }
  }
};

export const marketplaceTheme: ThemeConfig = {
  token: {
    colorPrimary: '#0D2772',
    colorTextSecondary: '#0D2772',
    colorTextLightSolid: '#fff',
    colorBgTextHover: 'rgba(0,0,0,0.06)'
  },
  components: {
    Button: {
      primaryShadow: '0px 1px 2px -1px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.1)'
    },
    Select: {
      colorBorder: '#d4d4d4',
      colorTextPlaceholder: '#a3a3a3'
    },
    DatePicker: {
      colorBorder: '#d4d4d4',
      colorTextPlaceholder: '#a3a3a3'
    },
    Input: {
      colorBorder: '#d4d4d4',
      colorTextPlaceholder: '#a3a3a3'
    },
    Tooltip: {
      colorBgSpotlight: 'rgba(0,0,0,0.85)'
    }
  }
};
